import { CalendarDays, Clock, ListOrdered, Users } from 'lucide-react';
import { Link } from 'react-router';
import type { TrainingCard as Card } from '@train2volley/shared';
import { formatWhen, totalsLabel } from '@/lib/training-time';

/** Trainingskaart in lijst en dashboard; hele kaart klikbaar, één tabstop. */
export function TrainingCard({ training: t }: { training: Card }) {
  return (
    <article className="group relative flex flex-col gap-3 rounded-xl border bg-card p-4 shadow-xs transition-[border-color,box-shadow] duration-120 hover:border-foreground/25 hover:shadow-md">
      {(t.scheduledAt || t.teamName) && (
        <p className="flex flex-wrap items-center gap-x-2 text-sm text-muted-foreground">
          {t.scheduledAt && (
            <span className="inline-flex items-center gap-1.5">
              <CalendarDays className="size-3.5" aria-hidden="true" />
              {formatWhen(t.scheduledAt)}
            </span>
          )}
          {t.scheduledAt && t.teamName && <span aria-hidden="true">·</span>}
          {t.teamName && <span>{t.teamName}</span>}
        </p>
      )}
      <h3 className="text-h4 font-semibold">
        <Link
          to={`/trainingen/${t.id}`}
          className="outline-none after:absolute after:inset-0 after:rounded-xl focus-visible:after:ring-2 focus-visible:after:ring-ring"
        >
          {t.title}
        </Link>
      </h3>
      {(!t.isMine || t.shared) && (
        <p className="-mt-1 flex items-center gap-1.5 text-sm text-muted-foreground">
          <Users className="size-3.5" aria-hidden="true" />
          {t.isMine ? 'Gedeeld met je club' : `Gedeeld door ${t.authorName}`}
        </p>
      )}
      <dl className="mt-auto flex flex-wrap gap-x-4 gap-y-1 text-sm text-muted-foreground tabular-nums">
        <div className="flex items-center gap-1.5">
          <dt className="sr-only">Oefeningen</dt>
          <ListOrdered className="size-3.5" aria-hidden="true" />
          <dd>
            {t.itemCount} {t.itemCount === 1 ? 'oefening' : 'oefeningen'}
          </dd>
        </div>
        <div className="flex items-center gap-1.5">
          <dt className="sr-only">Duur</dt>
          <Clock className="size-3.5" aria-hidden="true" />
          <dd>
            {totalsLabel(t.totals)}
            {t.targetDurationMinutes !== null && ` van ${t.targetDurationMinutes}`}
          </dd>
        </div>
      </dl>
    </article>
  );
}
